import Button from '@xunlei/thunder-ui-vue/lib/button.js';

var NAMESPACE = 'td';

var Pagination = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "td-pagination" }, [_c('td-button', { attrs: { "disabled": _vm.value === 1 || Boolean(_vm.loading), "secondary": "" }, on: { "click": _vm.handlePrev } }, [_vm._t("prev", [_vm._v(_vm._s(_vm.loading === 1 ? '加载中...' : '上一页'))])], 2), _vm._v(" "), _c('div', { staticClass: "td-pager" }, [_c('span', { staticClass: "td-pager__number is-active" }, [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('span', { staticClass: "td-pager__number" }, [_vm._v(_vm._s(_vm.total))])]), _vm._v(" "), _c('td-button', { attrs: { "disabled": _vm.value === _vm.total || Boolean(_vm.loading), "secondary": "" }, on: { "click": _vm.handleNext } }, [_vm._t("next", [_vm._v(_vm._s(_vm.loading === 2 ? '加载中...' : '下一页'))])], 2)], 1);
  }, staticRenderFns: [],
  name: NAMESPACE + '-pagination',

  components: {
    TdButton: Button
  },

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: Number,
    total: Number,
    beforeChange: Function
  },

  data: function data() {
    return {
      loading: 0
    };
  },


  methods: {
    prev: function prev() {
      this.loading = 0;
      this.$emit('change', this.value - 1);
    },
    next: function next() {
      this.loading = 0;
      this.$emit('change', this.value + 1);
    },
    handlePrev: function handlePrev() {
      if (this.value > 1) {
        if (this.beforeChange) {
          this.loading = 1;
          this.beforeChange(this.value - 1).then(this.prev);
        } else {
          this.prev();
        }

        this.$emit('prev-click');
      }
    },
    handleNext: function handleNext() {
      if (this.value < this.total) {
        if (this.beforeChange) {
          this.loading = 2;
          this.beforeChange(this.value + 1).then(this.next);
        } else {
          this.next();
        }

        this.$emit('next-click');
      }
    }
  }
};

Pagination.install = function (Vue) {
  Vue.component(Pagination.name, Pagination);
};

export default Pagination;
